import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { breakpointCodes } from 'rp-mq-breakpoints';
import classNames from 'classnames';
import DataTable from './GridDataTable';
import tableConfig from '../config/statisticsSalesTable';
import {
    initialTableUpdate
} from '../helpers/dispatchProps';
import SalesHeader from '../components/DataTable/StatisticsSalesHeader';

const stateKeyByDays = 'statisticsSalesByDays';
const stateKeyByHorseTypes = 'statisticsSalesByHorseTypes';

const getTableClass = isOverall =>
    classNames('table__StatisticsSales', { table__StatisticsSales_overall: isOverall });

const { EXTRA_NARROW, NARROW } = breakpointCodes;

/**
 * Container for statistics sales view
 */
function StatisticsSales(props) {
    function colSpanGetter(breakpoint) {
        switch (breakpoint) {
            case EXTRA_NARROW:
            case NARROW:
                return 4;
            default:
                return 10;
        }
    }

    return (
        <div>
            <div className={getTableClass(props.isByDaysOverall)} >
                <h2>Sales by day</h2>
                <DataTable
                    config={tableConfig}
                    stateKey={stateKeyByDays}
                    errorMessage="No sales found"
                    colSpanGetter={colSpanGetter}
                    onMount={initialTableUpdate('', stateKeyByDays)}
                    tableProps={{ headerComponent: SalesHeader }}
                />
            </div>
            <div className={getTableClass(props.isByHorseTypesOverall)} >
                <h2>Sales by horse type</h2>
                <DataTable
                    config={tableConfig}
                    stateKey={stateKeyByHorseTypes}
                    errorMessage="No sales found"
                    colSpanGetter={colSpanGetter}
                    onMount={initialTableUpdate('', stateKeyByHorseTypes)}
                    tableProps={{ headerComponent: SalesHeader }}
                />
            </div>
        </div>
    );
}

StatisticsSales.propTypes = {
    isByDaysOverall: PropTypes.bool,
    isByHorseTypesOverall: PropTypes.bool,
};

function mapStateToProps(state) {
    const rowsByDay = _.get(state, `${stateKeyByDays}.dataTable.rows`);
    const rowsByHorseTypes = _.get(state, `${stateKeyByHorseTypes}.dataTable.rows`);

    return {
        isByDaysOverall: rowsByDay.length > 1,
        isByHorseTypesOverall: rowsByHorseTypes.length > 1,
    };
}

export default connect(mapStateToProps)(StatisticsSales);



// WEBPACK FOOTER //
// ./src/js/containers/StatisticsSales.js